import {
  watchAddCourses,
  onBulkCoursesUpload,
} from 'redux/courses/sagas/addCourseSaga';
import { watchCourse } from 'redux/courses/sagas/getCourseSaga';
import { onCourseUpdate, onCourseDisabled } from 'redux/courses/sagas/updateCourseSaga';
import { onDeleteCourse } from 'redux/courses/sagas/deleteCourseSaga';
import { getCourseApplicants } from 'redux/courses/sagas/getApplicantsSaga';
import { getCourseDetails } from 'redux/courses/sagas/courseDetailsSaga';
import { searchSagas } from 'redux/courses/sagas/searchCourseSaga';
import { onDownloadCourseTemplate } from 'redux/courses/sagas/downloadCourseTemplateSaga';
import { call, all } from 'redux-saga/effects';

export default function* coursesSaga() {
  yield all([
    call(watchAddCourses),
    call(onBulkCoursesUpload),
    call(watchCourse),
    call(onCourseUpdate),
    call(onCourseDisabled),
    call(onDeleteCourse),
    call(getCourseApplicants),
    call(getCourseDetails),
    call(searchSagas),
    call(onDownloadCourseTemplate),
  ]);
}
